import styled from 'styled-components';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

Body.displayName = 'Body';

export default Body;
